import { render } from "./ProductsEditMultiple.vue?vue&type=template&id=4d4060e2&scoped=true"
import script from "./ProductsEditMultiple.vue?vue&type=script&lang=js"
export * from "./ProductsEditMultiple.vue?vue&type=script&lang=js"

import "./ProductsEditMultiple.vue?vue&type=style&index=0&id=4d4060e2&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4060e2"]])

export default __exports__